import './loadingEllipsis.scss';
import React from 'react';

const LoadingEllipsis = () => (
    <span className='chart_donutLabel loadingChart'>
        <span>.</span>
        <span>.</span>
        <span>.</span>
    </span>
);

export default LoadingEllipsis;
